import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import RichTextEditor from '../../../components/Editor/RichTextEditor';
import { IndesignTextFieldsConfig } from '../utils/indesignEditor/editableTextFields/getData';
import { HtmlTextFieldsConfig } from '../utils/htmlEditor/editableTextFields/getData';

const isPropInData = (prop: string, data: IndesignTextFieldsConfig | HtmlTextFieldsConfig): boolean => (
	prop in data ? data[prop] : undefined
);

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			type,
			editableTextFields,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
			pagesController: { spreads },
			isAccessibleVersion,
		},
	} = state;

	const { page, id, isEdited } = ownProps;
	const data = editableTextFields[page][id];
	const { width, height, content } = data;
	const isActive = id === activeItem.id && page === activeItem.page;

	return {
		editorType: type,
		width,
		height,
		content,
		isActive,
		activeParentId: activeItem.parentId,
		isEditPanelDisplayed,
		shouldShowScrollbar: isActive || isEdited || !!isPropInData('isEditedFromBackoffice', data),
		selfScale: isPropInData('selfScale', data),
		transformStyle: isPropInData('transformStyle', data),
		parentId: isPropInData('parentId', data),
		verticalAlignClassName: isPropInData('verticalAlignClassName', data),
		spreads,
		isThemedItem: isPropInData('isThemedItem', data),
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(RichTextEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/RichTextEditor/index.tsx